export const DEFAULT_PO_OPTIONS = [
  {
    poNumber: "PO12345",
    poSupplierCode: "SUP001",
    poSupplierName: "Jhon Doe",
    poDate: "2025/10/12",
  },
  {
    poNumber: "PO12345",
    poSupplierCode: "SUP001",
    poSupplierName: "Jhon Doe",
    poDate: "2025/10/12",
  },
];

export const CREATE_GRN_TEXT = {
  PAGE_TITLE: "Create GRN",
  SEARCH_BY_SUPPLIER: "Supplier",
  FILTER_DATE_RANGE_TITLE: "Filter by Date Range",
  DATE_FROM_LABEL: "From",
  DATE_TO_LABEL: "To",
  MENU_VIEW: "View",
  TAB_SUPPLIER_DETAILS: "Supplier Details",
  TAB_BILLING_INFO: "Financial Information",
  BUTTON_CANCEL: "Cancel",
  BUTTON_SAVE: "Save",
  BUTTON_HOLD: "Hold",
  BUTTON_NEXT: "Next",
  CONFIRM_CANCEL_TITLE: "Confirm Cancel",
  CONFIRM_CANCEL_MESSAGE:
    "Are you sure you want to cancel? Unsaved changes will be lost.",
  CONFIRM_SAVE_TITLE: "Confirm Save",
  CONFIRM_SAVE_MESSAGE: "Are you sure you want to save this GRN?",
  ACTION_NO: "No",
  ACTION_YES: "Yes",
  UNKNOWN_TAX_CODE: "unknown",
} as const;

export const CREATE_GRN_UI = {
  RIGHT_SIDEBAR_WIDTH_PX: 320,
  RIGHT_SIDEBAR_WIDTH: "320px",
  RIGHT_SIDEBAR_HIDDEN_OFFSET: "-400px",
  ATTACHMENTS_WIDTH: "50%",
  DESKTOP_NAV_WIDTH_PX: 260,
  GRID_ID: "field",
  PROCESS_DEBOUNCE_MS: 500,
} as const;

export const CREATE_GRN_TAB_INDEX = {
  SUPPLIER_DETAILS: 0,
  BILLING_INFO: 1,
  BILLING: 2,
} as const;

export const EDIT_GRN_UI = {
  RIGHT_SIDEBAR_WIDTH_PX: 320,
  RIGHT_SIDEBAR_WIDTH: "320px",
  RIGHT_SIDEBAR_HIDDEN_OFFSET: "-400px",
  ATTACHMENTS_WIDTH: "40%",
  DESKTOP_NAV_WIDTH_PX: 260,
  GRID_ID: "field",
} as const;

export const EDIT_GRN_TAB_INDEX = {
  SUPPLIER_DETAILS: 0,
  BILLING_INFO: 1,
} as const;

export const CREATE_GRN_DEFAULT_CAL_SUMMARY = {
  totgross: 0,
  tottax: 0,
  totdiscount: 0,
  totcharges: 0,
  totnett: 0,
} as const;

export const createGrnProcessResponse = () => ({
  dtCalProducts: [],
  dtCalCharges: [],
  dtCalSummary: [{ ...CREATE_GRN_DEFAULT_CAL_SUMMARY }],
});
